<template>
  <a-spin :spinning="spinning">
    <section>
      <div class="modal-header">
        <div class="modal-title">
          <a-icon type="profile" />
          <span>项目关联表单</span>
        </div>
      </div>
      <!-- <react-table
        :table-data="tableData"
        :total-items="totalItems"
        :actions-type="actionsType"
        :columns="columns"
        :hide-row-selection="true"
        :hide-pagination="false"
        :current-page="pageNumber"
      > -->
      <ele-table
        :columns="columns"
        :table-data="tableData"
        :total-items="totalItems"
        :current-page="pageNumber"
        :actions-type="actionsType"
        :is-full="false"
        :hide-row-selection="true"
        :hide-pagination="false"
      >
        <a-row :gutter="8" class="btn--container">
          <a-col class="gutter-row" :span="8">
            <a-input
              v-model="searchDto.filterText"
              :placeholder="l('SearchWithThreeDot')"
            />
          </a-col>
          <a-col class="gutter-row" :span="8">
            <a-button type="primary" @click="search">
              {{ l("Search") }}
            </a-button>
            <a-button @click="refreshGoFirstPage"> {{ l("Reset") }}</a-button>
          </a-col>
        </a-row>
      </ele-table>

      <div class="modal-footer">
        <a-button :disabled="saving" @click="close()" type="button">
          <a-icon type="close-circle" />
          {{ l("关闭") }}
        </a-button>
        <a-button
          :loading="saving"
          :type="'primary'"
          @click="createOrEdit(null, 'create')"
        >
          <a-icon type="plus" />
          {{ l("添加") }}
        </a-button>
      </div>
    </section>
  </a-spin>
</template>

<script>
import { AppComponentBase, ModalComponentBase } from "@/shared/component-base";
import { ModalHelper } from "@/shared/helpers";
import Bus from "@/shared/bus/bus";
import EleTable from "@/components/ele-table";
import ReactModify from "@/components/react-modify";
import { CommonServiceProxy } from "@/shared/common-service";
import { fileDownloadService } from "@/shared/utils";
import moment from "moment";
import CollectionFormDetail from "./collectionformdetail.vue";

export default {
  name: "provide",
  mixins: [AppComponentBase, ModalComponentBase],
  components: { EleTable },
  data() {
    return {
      spinning: false,
      commonService: null,
      selectedRowKeys: [],
      name: "",
      filterText: "",
      searchDto: {
        filterText: "",
      },
      // 总数
      totalItems: 0,
      // 当前页码
      pageNumber: 1,
      // 共多少页
      totalPages: 1,
      // 条数显示范围
      pagerange: [1, 1],
      // 显示条数
      pageSizeOptions: ["10", "20", "30", "40"],
      request: { sorting: "", maxResultCount: 50, skipCount: 0 },
      // 用户表格
      columns: [
        {
          title: this.l("表单名称"),
          dataIndex: "formName",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "formName" },
        },
        //  {
        //   title: this.l("状态"),
        //   dataIndex: "status",
        //   sorter: false,
        //   align: "center",
        //   scopedSlots: { customRender: "status" },
        // },
        {
          title: this.l("收集开始时间"),
          dataIndex: "formStartTime",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "formStartTime" },
        },
        {
          title: this.l("收集结束时间"),
          dataIndex: "formEndTime",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "formEndTime" },
        },
        {
          title: this.l("表单状态"),
          dataIndex: "statusName",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "statusName" },
        },
        {
          title: this.l("Actions"),
          dataIndex: "actions",
          sorter: false,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "actions" }, //
        },
      ],
      // 用户数据
      tableData: [],
      // btns
      actionsType: {},
      // 保存页面参数中介
      getDataParams: [],
    };
  },
  computed: {},
  created() {
    this.fullData();
    this.commonService = new CommonServiceProxy(this.$apiUrl, this.$api);
    this.initActionsType();
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
    });
  },
  beforeDestroy() {},
  methods: {
    search() {
      this.pageNumber = 1
      this.request.skipCount = 0
      this.getData()
    },
    // 拉取数据
    async getData() {
      this.spinning = true;
      let params = {
        projectId: this.id,
        formName: this.searchDto.filterText,
        filterText: "",
        sorting: this.request.sorting,
        maxResultCount: this.request.maxResultCount,
        skipCount: this.request.skipCount,
      };
      try {
        let res = await this.commonService.get({
          url: "/api/services/app/UnnaturalPersonProjectForm/GetPaged",
          params: params,
        });
        console.log(res);
        this.spinning = false;
        this.tableData = res.items.map((o) => {
          return {
            ...o,
            // status: o.status === "Enabled" ? "正常" : "禁用",
            // formStatus: o.formStatus === "Enable" ? "正常" : "禁用",
            formStartTime: o.formStartTime
              ? moment(o.formStartTime).format("YYYY-MM-DD HH:mm:ss")
              : "-",
            formEndTime: o.formEndTime
              ? moment(o.formEndTime).format("YYYY-MM-DD HH:mm:ss")
              : "-",
          };
        });
        this.totalItems = res.totalCount;
        this.pagerange = [
          (this.pageNumber - 1) * this.request.maxResultCount + 1,
          this.pageNumber * this.request.maxResultCount,
        ];
        this.totalPages = Math.ceil(
          res.totalCount / this.request.maxResultCount
        );
      } catch (error) {
        this.spinning = false;
      }
    },
    // 初始化需要显示的func btn
    initActionsType() {
      let _this = this;
      let obj = {
        type: "project-form",
        isShow: true,
        fns: {
          dropList: [
            {
              granted: true,
              name: this.l("采集详情"),
              icon: "profile",
              fn: (data) => {
                _this._getCollectionFormDetail(data.id);
                // _this.createOrEdit(newV.item, 'preview');
                // _this.createOrEdit(newV.item, 'create');
              },
            },
            {
              granted: true,
              name: this.l("修改"),
              icon: "edit",
              fn: (data) => {
                _this.createOrEdit(data, "edit");
                // _this.createOrEdit(newV.item, 'preview');
                // _this.createOrEdit(newV.item, 'create');
              },
            },
            {
              granted: true,
              name: this.l("状态变更"),
              icon: "swap",
              fn: (data) => {
                _this._statusChange(data.id);
                // _this.createOrEdit(newV.item, 'preview');
                // _this.createOrEdit(newV.item, 'create');
              },
            },
          ],
        },
      };
      this.actionsType = obj;
    },
    async _statusChange(id) {
      this.spinning = true;
      try {
        const res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonProjectForm/StatusChange",
          params: { id: id },
        });
        this.spinning = false;
        this.$message.success("状态变更成功");
        this.getData();
      } catch (error) {
        this.spinning = false;
        this.$message.error("状态变更失败");
      }
    },
    async _getFormSelectList() {
      this.spinning = true;
      try {
        const res = await this.commonService.get({
          url: "/api/services/app/Form/GetSelectList",
          params: { formType: 1 },
        });
        this.spinning = false;
        let arr = res.map((item) => {
          return {
            label: item.text,
            value: item.value,
          };
        });
        return arr;
      } catch (error) {
        this.spinning = false;
      }
    },
    // 增加修改查看
    async createOrEdit(item, type) {
      let reqParams = [];
      const list = [
        {
          label: "采集表单",
          value: "collectionFormId",
          type: "commonSelect",
          disabled: false,
          required: true,
          rules: [{ required: true, message: "请选择采集表单" }],
          defaultValue:
            item && item.id
              ? item.collectionFormId.toUpperCase()
              : "请选择采集表单",
          defaultSelectList: await this._getFormSelectList(),
          changeFn: (e) => {
            console.log(e);
            if (item && item.id) {
              reqParams.push({
                key: "collectionFormId",
                value: e,
              });
            }
          },
        },
        // {
        //   label: "状态",
        //   value: "status",
        //   type: "switch",
        //   disabled: false,
        //   required: true,
        //   rules: [],
        //   changeFn: () => {},
        // },
      ];
      if (item && item.id) {
        reqParams.push({ key: "id", value: item.id });
      }
      let otherPrams = {};
      ModalHelper.create(
        ReactModify,
        {
          params: {
            type: type, // edit,preview,create
            data: list,
            reqParams: [
              ...reqParams,
              { key: "unnaturalPersonProjectId", value: this.id },
            ],
            reqUrl: {
              getById: "",
              save:
                item && item.id
                  ? "/api/services/app/UnnaturalPersonProjectForm/Update"
                  : "/api/services/app/UnnaturalPersonProjectForm/Create",
            },
            otherParams: {},
            getItemfn: async (res, form, options) => {
              let collectionFormIdValue = item.collectionFormId.toUpperCase();
              form.setFieldsValue({ collectionFormId: collectionFormIdValue });
              if (options) {
                // ...
              }
            },
            submitfn: async (values, queryParams) => {
              let obj = {};
              queryParams.reqParams.map((item) => {
                obj[item.key] = item.value;
              });
              Object.assign(values, obj);
              // console.log(values)
              try {
                let res = await this.commonService.post({
                  url: queryParams.reqUrl.save,
                  params: {
                    ...values,
                    status: queryParams.otherParams.status ? 1 : 0,
                  },
                });
                return true;
              } catch (error) {
                return false;
              }
            },
          },
        },
        {
          isChange: true,
          width: "800px",
        }
      ).subscribe((res) => {
        if (res) {
          // this.clearFilterAndRefresh();
          this.getData();
        }
      });
    },
    refreshGoFirstPage() {
      this.searchDto.filterText = "";
      this.getData();
    },
    _getCollectionFormDetail(id) {
      ModalHelper.create(
        CollectionFormDetail,
        { id: id },
        {
          isChange: true,
          width: "1200px",
        }
      ).subscribe((res) => {
        if (res) {
          this.refreshGoFirstPage();
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.modal-header {
  // margin-bottom: 0;
  .anticon {
    margin-right: 10px;
  }
}
.opeattion-container {
  margin: 20px 0;
}
.pagination {
  margin: 10px auto;
  text-align: right;
}
</style>
